import { AnalyticsEvent } from '../../core/AnalyticsEvent'
import { ButtonClickedEventSchema } from '../../schemas/buttonClickEvents/ButtonClickedsEventSchema'
import { CommonEventParams } from '../../utils/CommonParams'

export interface ButtonClickEventParams extends CommonEventParams {
  BUSINESS_VERTICAL: string
  EVENT_CATEGORY: string
  BUTTON_NAME: string
  BUTTON_TYPE: string
}

export class ButtonClickEvent extends AnalyticsEvent {
  constructor(params: ButtonClickEventParams, schema: any = ButtonClickedEventSchema) {
    super(schema(), ['segment'])
    this.createEventObject(params)
  }
}

